// extracted by mini-css-extract-plugin
var _1 = "OYWrPq4XyoERuSJaCxt6";
var _2 = "g0kKFFFO40Q90GaGdMIQ";
var _3 = "iPW3Kz4I1Riv_I6Zgs2x";
var _4 = "jD0U_JaULPtv54uU3iee";
var _5 = "k6uYR6T8zJSznmSrOZoM";
var _6 = "X_kbQEaTZjSsIb4WV7fD";
var _7 = "alMlL30IuzZ_BlJP6Ats";
var _8 = "TTTr8IFK9TfghVuAcYGQ";
var _9 = "N2ab5YoK4S_2tB4W4s_m";
var _a = "Mvp4v9uK7za05rq9ZeoH";
var _b = "G5R57c6GE83K6dxUG55_";
var _c = "MEzuWDF3H6uydzeHTVBB";
var _d = "rGxCP95X0rQxx4IaAtNs";
var _e = "Z5NcSov5I9Ic6LBKyqRc";
var _f = "PQdUCtH4zuj3xg1ZGvpg";
var _10 = "ep1XTxsWHbIbpDYaZijN";
var _11 = "U_7DiKFsvxnnQQhXRJKo";
var _12 = "Zt6Neaje9Sp3eAvPtgaq";
var _13 = "txp9mD58pp0bM8F0SQhp";
var _14 = "NlzW9YSad0j5VKphvKJm";
var _15 = "SpbSgARCpBH6muOtJvdY";
var _16 = "Ck1mHLMrVyYdp8E0Cgdj";
var _17 = "WBVE4Bc5nOP0usSphiAF";
export { _1 as "inline", _2 as "is-128x128", _3 as "is-16x16", _4 as "is-24x24", _5 as "is-32x32", _6 as "is-48x48", _7 as "is-64x64", _8 as "is-96x96", _9 as "list", _a as "primary", _b as "secondary", _c as "theme-cardiology", _d as "theme-dermatology", _e as "theme-empty", _f as "theme-lab", _10 as "theme-mentalHealth", _11 as "theme-ophthalmology", _12 as "theme-pulmonology", _13 as "theme-referall", _14 as "theme-sleep", _15 as "theme-white-theme", _16 as "theme-xyz", _17 as "white" }
